var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgUnknown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 105,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#unknown_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 45,
  r: 24,
  stroke: "#000",
  strokeWidth: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 40,
  cy: 45,
  r: 20.5,
  fill: "#F7F7F9",
  stroke: "#F7F7F9",
  strokeWidth: 5
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38.48 47.888c-.032-.736 0-1.36.096-1.872s.288-.968.576-1.368c.288-.416.68-.808 1.176-1.176l1.248-.888c.496-.368.848-.704 1.056-1.008.224-.32.336-.648.336-.984 0-.368-.112-.688-.336-.96a2.195 2.195 0 0 0-.912-.672 3.136 3.136 0 0 0-1.32-.264c-.72 0-1.384.184-1.992.552a3.665 3.665 0 0 0-1.392 1.488l-2.64-1.104a5.912 5.912 0 0 1 1.44-1.968 6.707 6.707 0 0 1 2.112-1.272 7.364 7.364 0 0 1 2.592-.456c1.088 0 2.056.2 2.904.6.848.384 1.52.912 2.016 1.584a3.78 3.78 0 0 1 .744 2.304c0 .576-.096 1.096-.288 1.56-.176.448-.48.888-.912 1.32-.432.432-1.024.904-1.776 1.416l-.648.456c-.512.336-.872.712-1.08 1.128-.192.416-.272.944-.24 1.584h-2.76Zm1.392 5.352c-.528 0-.984-.192-1.368-.576a1.869 1.869 0 0 1-.576-1.368c0-.544.192-1.008.576-1.392.384-.384.84-.576 1.368-.576.528 0 .984.192 1.368.576.384.384.576.848.576 1.392 0 .528-.192.984-.576 1.368-.384.384-.84.576-1.368.576Z",
  fill: "#E07900"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "unknown_svg__a",
  x: 11,
  y: 20,
  width: 58,
  height: 58,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3714_347519"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3714_347519",
  result: "shape"
})))));

export { SvgUnknown as ReactComponent };
export default __webpack_public_path__ + "335d2bd2e5690f0e386dacbfdbbe1857.svg";